<template>
    <CFormGroup :error="error" :label="$t('ui.fields.lastName', lang)" :required="required">
        <CFormInput
            autocomplete="family-name"
            data-test-id="profileForm.lastName"
            :disabled="disabled"
            :model-value="modelValue"
            v-bind="$attrs"
            @update:model-value="$emit('update:modelValue', $event)"
            @change="$emit('change', $event)"
        />
        <slot />
        <template #side>
            <slot name="side" />
        </template>
        <template #footer>
            <slot name="footer" />
        </template>
    </CFormGroup>
</template>

<script setup lang="ts">
import CFormGroup from '@/components/ui/CFormGroup.vue'
import CFormInput from '@/components/ui/CFormInput.vue'

defineProps({
    modelValue: {
        type: String,
        default: undefined
    },
    disabled: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    lang: {
        type: String,
        default: 'sk'
    },
    error: {
        type: String,
        default: undefined
    }
})

defineEmits(['update:modelValue', 'change'])
</script>